import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import { FaCode, FaEnvelope, FaMedal } from "react-icons/fa";

const AboutHome = ({
  imageSrc = "/img/LV.png",
  onContactClick,
}) => {
  const scrollToContact = () => {
    if (typeof onContactClick === "function") {
      onContactClick();
      return;
    }

    const contactSection = document.getElementById("contact");

    if (contactSection) {
      window.scrollTo({
        top: contactSection.offsetTop - 90,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="relative overflow-hidden bg-white py-14 text-slate-950 dark:bg-[#07111f] dark:text-white sm:py-20">
      <div className="absolute -left-32 top-10 h-72 w-72 rounded-full bg-sky-500/10 blur-3xl" />
      <div className="absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-orange-400/10 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-[0.42fr_0.58fr]">
          <Slide direction="left" triggerOnce cascade damping={0.12}>
            <div className="mx-auto w-full max-w-[300px] lg:max-w-[340px]">
              <div className="relative">
                <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-sky-500/20 via-transparent to-orange-400/20 blur-xl" />

                <div className="relative overflow-hidden rounded-[1.8rem] border border-slate-200 bg-slate-100 p-2 shadow-xl shadow-slate-200/70 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/30">
                  <img
                    src={imageSrc}
                    alt="Laurent Victorin, créateur de Judo Coach Pro"
                    className="h-[330px] w-full rounded-[1.45rem] object-cover object-center grayscale transition duration-500 hover:grayscale-0"
                  />
                </div>

                <div className="absolute -bottom-5 left-1/2 w-[86%] -translate-x-1/2 rounded-2xl border border-white/70 bg-white/90 px-4 py-3 text-center shadow-lg backdrop-blur dark:border-white/10 dark:bg-slate-950/85">
                  <p className="font-heading text-lg font-semibold text-slate-950 dark:text-white">
                    Laurent VICTORIN
                  </p>
                  <p className="mt-1 text-xs font-semibold tracking-[0.18em] text-sky-700 dark:text-sky-300">
                    Créateur de MonAppliClub
                  </p>
                </div>
              </div>
            </div>
          </Slide>

          <Fade direction="up" triggerOnce cascade damping={0.12}>
            <div className="pt-8 lg:pt-0">
              <div className="inline-flex items-center gap-2 rounded-full border border-sky-200 bg-sky-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-sky-700 dark:border-sky-400/20 dark:bg-sky-500/10 dark:text-sky-200">
                <FaMedal />
                Pensé sur le tatami
              </div>

              <h2 className="mt-5 max-w-3xl font-heading text-3xl font-bold leading-tight text-slate-950 dark:text-white sm:text-4xl lg:text-5xl">
                Une application créée par un coach, pour les coachs.
              </h2>

              <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-slate-600 dark:text-white/60 sm:text-lg">
                Je suis développeur web fullstack, président et enseignant de
                judo au Bouscat. J’ai créé Judo Coach Pro pour répondre à un
                besoin simple : mieux suivre les judokas, leurs grades, leurs
                compétitions et leur progression.
              </p>

              <div className="mt-7 border-l-4 border-orange-400 pl-5">
                <p className="text-lg font-semibold leading-8 text-slate-800 dark:text-white/85">
                  Un outil concret, pratique et accessible, conçu pour gagner du
                  temps tout au long de la saison.
                </p>
              </div>

              <div className="mt-7 flex flex-wrap gap-3 text-sm font-bold text-slate-600 dark:text-white/55">
                <span className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 dark:bg-white/[0.07]">
                  <FaCode className="text-sky-600 dark:text-sky-300" />
                  Développement français
                </span>

                <span className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 dark:bg-white/[0.07]">
                  <FaMedal className="text-orange-500" />
                  100% judo
                </span>
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={scrollToContact}
                  className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-600 to-blue-800 px-6 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 active:translate-y-0 font-ui"
                >
                  <FaEnvelope />
                  Me contacter
                </button>

                <a
                  href="/espace-coach"
                  className="inline-flex min-h-12 items-center justify-center rounded-2xl border border-slate-200 bg-white px-6 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-white/10 dark:bg-white/[0.07] dark:text-white font-ui"
                >
                  Découvrir l’espace coach
                </a>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default AboutHome;